export default __webpack_public_path__ + "static/media/kolporter-big.2325abfd.png";